import { initTurnstileWidgets, resetFormTurnstile } from './turnstile.js';
/**
 * Turnstile
 */
function whenTurnstileReady(callback) {
    if (window.turnstile) {
        callback();
        return;
    }

    const interval = setInterval(() => {
        if (window.turnstile) {
            clearInterval(interval);
            callback();
        }
    }, 50);
}

document.addEventListener('DOMContentLoaded', () => {
    whenTurnstileReady(initTurnstileWidgets);
});

window.initTurnstileWidgets = initTurnstileWidgets;
window.resetFormTurnstile = resetFormTurnstile;

import * as Sentry from "@sentry/browser";
import 'fslightbox'

Sentry.init({
  dsn: "https://3ca775afcc4e07c9c7580c50ef855571@o4508358341033984.ingest.de.sentry.io/4508931672899664",
  environment: import.meta.env.MODE || 'development'
});

/**
 *
 * Carousels
 *
 */
import Glide from '@glidejs/glide'

initHomeCarousels();

function initHomeCarousels() {
  document.querySelectorAll('.homepage-events-training-carousel').forEach((element) => {
      new Glide(element, {
        type: 'carousel',
          perView: 3,
          gap: 40,
          autoplay: 3000,
          rewindDuration: 800,
          hoverPause: true,
          keyboard: false,
          breakpoints: {
              1280: {
                perView: 2
              },
              1024: {
                  perView: 1
              },
          }
      }).mount();
  });

  document.querySelectorAll('.home-testimonials-carousel').forEach((element) => {
      new Glide(element, {
          type: 'carousel',
          perView: 3,
          gap: 50,
          autoplay: 3000,
          rewindDuration: 800,
          hoverPause: true,
          keyboard: false,
          breakpoints: {
              768: {
                  perView: 2
              }
          }
      }).mount()
  });
}

document.querySelectorAll('.bookable-sponsors-carousel').forEach((element) => {
  new Glide(element, {
    perView: 6,
    gap: 20,
    bound: true,
    autoplay: 3000,
    rewindDuration: 800,
    keyboard: false,
    breakpoints: {
      300: {
        gap: 10,
        perView: 2
      },
      510: {
        gap: 10,
        perView: 3
      },
      768: {
        gap: 10,
        perView: 4
      },
      1024: {
        gap: 10,
        perView: 5
      },
      1280: {
        gap: 20,
        perView: 6
      }
    }
  }).mount()
});

document.querySelectorAll('.home-contributors-carousel').forEach((element) => {
  new Glide(element, {
    perView: 8,
    gap: 0,
    bound: true,
    autoplay: 3000,
    rewindDuration: 800,
    keyboard: false,
    breakpoints: {
      300: {
        perView : 1
      },
      574: {
        perView : 2,
      },
      768: {
        perView : 3,
      },
      1024: {
        perView : 4,
      },
      1280: {
        perView : 5,
      },
      1740: {
        perView : 6,
      },
      1920: {
        perView : 7,
      },
    }
  }).mount()
});

function initVenueCarousel() {
  document.querySelectorAll('.event-venue-images').forEach((element) => {
    new Glide(element).mount()
  });
}

addEventListener('page:loaded', initVenueCarousel);
addEventListener('page:loaded', initHomeCarousels);
addEventListener('page:loaded', refreshFsLightbox);

/**
 *
 * Alpine.js
 *
 */
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

/**
 *
 * WebFont Loader.
 *
 */
import WebFont from 'webfontloader';
WebFont.load({
    google: {
        families: ['Inter:100,200,300,400,500,600,700,800,900']
    }
});

addEventListener('page:loaded', initScheduleFilters);

initScheduleFilters();

function initScheduleFilters() {
    const courseFilters = document.getElementById('course-filters');
    if (courseFilters) {
      courseFilters.addEventListener('change', getCourses);
    }

    const eventsFilters = document.getElementById('events-filters');
    if (eventsFilters) {
      eventsFilters.addEventListener('change', getEvents);
    }
}

/**
 * Events Filters
 */
function getEvents() {
    oc.request('#events-filters', 'onSearchEvents', {
        loading: '.is-loading',
        query: getEventFiltersObject(),
        data: {
            page: 1
        },
        update: {
            '@results': true
        }
    });
}

function getEventFiltersObject() {
  var formData = new FormData(document.getElementById('events-filters'));
  var filters = {
      page: 1
  };
  formData.forEach((value, key) => {
      filters[key] = value;
  });
  return filters;
}

/**
 * Course Filters
 */

function getCourses() {
    oc.request('#course-filters', 'onSearchCourses', {
        loading: '.is-loading',
        query: getCourseFiltersObject(),
        data: {
            page: 1
        },
        update: {
            '@results': true
        }
    });
}

function getCourseFiltersObject() {
  var formData = new FormData(document.getElementById('course-filters'));
  var filters = {
      page: 1
  };
  formData.forEach((value, key) => {
      filters[key] = value;
  });
  return filters;
}